/* eslint-disable import/prefer-default-export */
const FETCH_SCHEDULE = 'app/schedule/FETCH_SCHEDULE';
const SET_SCHEDULE = 'app/schedule/SET_SCHEDULE';
const UPDATE_SCHEDULE = 'app/schedule/UPDATE_SCHEDULE';
const RUN_SCHEDULE = 'app/schedule/RUN_SCHEDULE';
const LAST_WATERED = 'app/schedule/LAST_WATERED';
const SET_LAST_WATERED = 'app/schedule/SET_LAST_WATERED';
const SET_UPCOMING_WATERED = 'app/schedule/SET_UPCOMING_WATERED';
const GET_CALENDAR_DATES = 'app/schedule/GET_CALENDAR_DATES';
const SET_CALENDAR_DATES = 'app/schedule/SET_CALENDAR_DATES';
const GET_SCHEDULE_FOR_DAY = 'app/schedule/GET_SCHEDULE_FOR_DAY';
const SET_SCHEDULE_FOR_DAY = 'app/schedule/SET_SCHEDULE_FOR_DAY';
const GET_CURRENT_WATERING = 'app/schedule/GET_CURRENT_WATERING';
const SET_CURRENT_WATERING = 'app/schedule/SET_CURRENT_WATERING';
const MODIFY_SCHEDULE = 'app/schedule/MODIFY_SCHEDULE';
const NEW_SCHEDULE = 'app/schedule/NEW_SCHEDULE';
const STOP_SCHEDULE_LOADER = 'app/schedule/STOP_SCHEDULE_LOADER';
const DELETE_SCHEDULE = 'app/schedule/DELETE_SCHEDULE';
const DELETE_SCHEDULE_SUCCESS = 'app/schedule/DELETE_SCHEDULE_SUCCESS';
const STOP_WATERING = 'app/schedule/STOP_WATERING';
const SKIP_WATERING = 'app/schedule/SKIP_WATERING';

export {
  FETCH_SCHEDULE,
  UPDATE_SCHEDULE,
  SET_SCHEDULE,
  RUN_SCHEDULE,
  LAST_WATERED,
  SET_LAST_WATERED,
  SET_UPCOMING_WATERED,
  GET_CALENDAR_DATES,
  SET_CALENDAR_DATES,
  GET_SCHEDULE_FOR_DAY,
  SET_SCHEDULE_FOR_DAY,
  GET_CURRENT_WATERING,
  SET_CURRENT_WATERING,
  MODIFY_SCHEDULE,
  NEW_SCHEDULE,
  STOP_SCHEDULE_LOADER,
  DELETE_SCHEDULE,
  DELETE_SCHEDULE_SUCCESS,
  STOP_WATERING,
  SKIP_WATERING,
};
